import React from "react";
import JumboPayTableBody from "./JumboPayTableBody.js";
import JumboPayTableHeader from "./JumboPayTableHeader.js";
import "./JumboPayTable.scss";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";

const JumboPayTableContainer = ({
  headerTable,
  data,
  tableSecture,
  emptyTransactions = false,
  emptyTransactionsText = "",
  loading = false,
  mobileRowRender = null,
}) => {
  const { getTextByKey } = useContent();
  const mainRender = () => {
    if (loading) {
      return <Skeleton count={3} width="100%" height={44} />;
    } else {
      if (emptyTransactions) {
        return (
          <div className="empty-transactions">
            {" "}
            <div className="no-balance">
              <Image name="profile-jumbopay/empty" ext="svg" alt="" title="" />
              <span>{getTextByKey(emptyTransactionsText)}</span>
            </div>
          </div>
        );
      } else {
        return (
          <>
            <div className="jumbopay-table-container">
              <JumboPayTableHeader headerTable={headerTable} />
              <JumboPayTableBody data={data} tableSecture={tableSecture} />
            </div>
            {mobileRowRender && (
              <div className="mobile-table">
                {data ? data.map((item, i) => mobileRowRender(item, i)) : null}
              </div>
            )}
          </>
        );
      }
    }
  };

  return mainRender();
};

export default JumboPayTableContainer;
